<template>
  <div class="row justify-content-center align-items-md-center">
    <div class="col-md-6">
      <div class="card full-height bg-ligth">
        <div class="card-header">
          <h3 class="mb-0">
            {{ lista_campos != "" ? "Editar" : "Criar" }} sala
          </h3>
        </div>
        <div class="card-body">
          <div class="form">
            <div class="form-group row">
              <div class="col-md-8">
                <label class="col-md-12">Sigla:*</label>
                <input
                  required
                  type="text"
                  class="form-control"
                  v-model="form.sigla"
                  placeholder="Digite a sigla..."
                />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-8">
                <label class="col-md-12">Nome:*</label>
                <input
                  required
                  type="text"
                  class="form-control"
                  v-model="form.nome"
                  placeholder="Digite o nome..."
                />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-md-12">Descrição:*</label>
                <input
                  required
                  type="text"
                  class="form-control"
                  v-model="form.descricao"
                  placeholder="Digite a descrição..."
                />
              </div>

              <div class="col-md-12">
                <label class="col-md-12">Selecione o Setor:*</label>
                <select class="form-control" v-model="form.setor_id" id="">
                  <option
                    v-for="(lista, index) in lista_setor"
                    :key="index"
                    :value="lista.id"
                  >
                    {{ lista.nome }}
                  </option>
                </select>
              </div>

              <div class="col-md-12">
                <label class="col-md-12">Selecione o Local:*</label>
                <select class="form-control" v-model="form.local_id" id="">
                  <option
                    v-for="(lista, index) in lista_local"
                    :key="index"
                    :value="lista.id"
                  >
                    {{ lista.nome }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12 text-center">
                <button
                  @click="confirm(lista_campos == '' ? 'cria' : 'edita')"
                  class="btn btn-primary"
                  :disabled="verif"
                >
                  Salvar
                  <b-spinner
                    v-show="verif"
                    small
                    variant="dark"
                    type="grow"
                    label="Spinning"
                  ></b-spinner>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fireAlert } from "@/core/mixins/alertMessageMixin";

export default {
  mixins: [fireAlert],
  data() {
    return {
      form: {
        nome: "",
        sigla: "",
        descricao: "",
        setor_id: "",
        local_id: "",
        filial_id: "",
        status: 1,
        user_in: "user_in",
        user_up: "user_up",
      },
      verif: false,
    };
  },
  created() {
    this.listar_requerimentos();
    this.preenxerCampos();
  },
  computed: {
    lista_setor() {
      return this.$store.state.configEmpresa.lista_setor;
    },
    lista_filials() {
      return this.$store.state.configEmpresa.lista_filials;
    },
    lista_local() {
      return this.$store.state.configEmpresa.lista_local;
    },
    lista_campos() {
      return this.$store.state.configEmpresa.lista_campos;
    },
    mensagem_alert() {
      return this.$store.state.configEmpresa.mensagem_alert;
    },
  },
  methods: {
    async confirm(tipo) {
      await this.$confirm({
        title: "Estas seguro?",
        message: `Esta ação  ` + tipo + ` uma Sala no sistema?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            if (tipo == "cria") this.create();
            if (tipo == "edita") this.update();
          }
        },
      });
    },
    makeToast(variant = null) {
      this.$bvToast.toast("Salvo com sucesso", {
        title: "Sucesso",
        variant: variant,
        solid: false,
      });
    },
    async create() {
      this.verif = true;
      await this.$store.dispatch("configEmpresa/create_sala", this.form);
      this.verif = false;

      this.fireAlert({
        ...this.mensagem_alert,
        tipo: "success",
        routeName: "sala",
      });
    },
    async update() {
      this.verif = true;
      await this.$store.dispatch("configEmpresa/update_sala", this.form);
      this.verif = false;
      this.fireAlert({
        ...this.mensagem_alert,
        routeName: "sala",
      });
    },
    listar_requerimentos() {
      this.$store.dispatch("configEmpresa/listar_setor");
      this.$store.dispatch("configEmpresa/listar_local");
      this.$store.dispatch("configEmpresa/listar_filial");
    },
    preenxerCampos() {
      if (this.lista_campos != "")
        this.form = {
          id: this.lista_campos.id,
          nome: this.lista_campos.nome,
          sigla: this.lista_campos.sigla,
          setor_id: this.lista_campos.setor_id,
          descricao: this.lista_campos.descricao,
          status: this.lista_campos.status,
          user_in: this.lista_campos.user_in,
          user_up: this.lista_campos.user_up,
          filial_id: this.lista_campos.filial_id,
          local_id: this.lista_campos.local_id,
        };
    },
  },
};
</script>

<style scoped>
.lista:hover {
  background-color: rgb(167, 183, 255);
}
</style>